import { Component, ViewChild, Input } from '@angular/core';
import { displayQuoteLogAction } from 'src/shared/enums';
import { animateList } from 'src/shared/animations';
import { SelfDestruct } from 'src/shared/utilities/self-destruct';
import { QuoteLogSummary } from 'src/shared/api';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'rpshared-quote-log-table',
	templateUrl: './quote-log-table.component.html',
	animations: [animateList],
})
export class QuoteLogTableComponent extends SelfDestruct {
	@ViewChild(MatSort, { static: true }) set sort(sort: MatSort) {
		this.dataSource.sort = sort;
	}
	@ViewChild(MatPaginator, { static: true }) set paginator(
		paginator: MatPaginator
	) {
		this.dataSource.paginator = paginator;
	}
	@Input() set quoteLogs(quoteLogs: QuoteLogSummary[]) {
		this.dataSource.data = quoteLogs;
	}
	@Input() isLoading: boolean;
	@Input() listMessage: string;

	readonly displayQuoteLogAction = displayQuoteLogAction;
	readonly resultColumns = ['createdBy', 'note', 'date'];
	readonly emptyColumns = ['empty'];

	readonly dataSource = new MatTableDataSource();
}
